import React, { Component } from "react";
import { Col, Row, Container } from "react-bootstrap";
import RightComponentOrderTrack from "./RightComponentOrderTrack";

class OrderTrackMain extends Component {
  state = { phase: 1 };

  changePhase = (newPhase) => {
    this.setState({ phase: newPhase });
  };

  render() {
    const { phase } = this.state;
    return (
      <React.Fragment>
        <Row>
          <Col md={8}>
            <div>
              <h5>Track Order</h5>
              <br />
              <br />
              <p>
                Order ID: <span style={{ color: "#F85032" }}>214536878</span>
              </p>
              <hr />
              <h5>Order Status</h5>
              <br />
              <div style={{ padding: "15px", backgroundColor: "#FFFBEE" }}>
                <Row>
                  <Col xs={6}>
                    <b>
                      {phase === 0 && "Order Requested"}
                      {phase === 1 && "Order Confirmed"}
                      {phase === 2 && "Food Being Prepared"}
                      {phase === 3 && "Ready To Pick Up"}
                      {phase === 4 && "Food Delivered"}
                      {phase === 5 && "Order Completed"}
                    </b>
                  </Col>
                  <Col xs={6} align="right">
                    <button
                      className="btn"
                      style={{
                        backgroundColor: "#2196F3",
                        color: "#ffffff",
                        borderRadius: "15px",
                        boxShadow: "0px 5px 8px #6E6E6E57",
                      }}
                    >
                      Change Status
                    </button>
                  </Col>
                </Row>
                <Container fluid>
                  <b>
                    {phase === 0 && "Request Sent"}
                    {phase === 1 && "Order has been confirmed."}
                    {phase === 2 && "Order is being prepared."}
                    {phase === 3 && "Order is prepared."}
                    {phase === 4 &&
                      "The order has been delivered to `User's Name`."}
                    {phase === 5 && "Your service has been completed"}
                  </b>
                  <p style={{ color: "#747474" }}>
                    {phase === 0 &&
                      "An order request to Street Meat has been sent."}
                    {(phase === 1 || phase === 2 || phase === 3) &&
                      "Your order will take 45-50 mins."}
                    {phase === 4 && "Thank you."}
                    {phase === 5 && "Enjoy the service"}
                  </p>
                </Container>
              </div>
              <div style={{ backgroundColor: "#ffffff", padding: "20px" }}>
                <b>Order References</b>
                <Row>
                  <Col sm={6}>
                    <b>29th August 2019</b>
                    <p style={{ color: "#747474" }}>Requested Date</p>
                  </Col>
                  <Col sm={6}>
                    <b>09:30 PM</b>
                    <p style={{ color: "#747474" }}>Requested Time</p>
                  </Col>
                </Row>
              </div>
              <div>
                <SliderMenu changePhase={this.changePhase} phase={phase} />
              </div>
              <div>
                <h5>Order Details</h5>
                <hr />
                <Row style={{ padding: "20px" }}>
                  <Col md={4} sm={6}>
                    <img
                      src={require("../../../../assets/images/superadmin/ordericon/rupees.svg")}
                      width="30px"
                      alt="Rupees"
                    />{" "}
                    <b>895</b>
                    <p style={{ color: "#717171" }}>Total Amount</p>
                  </Col>
                  <Col md={4} sm={6}>
                    <b>Paytm </b>
                    <span className="badge badge-success">Paid</span>
                    <p style={{ color: "#717171" }}>Payment Type</p>
                  </Col>
                  <Col md={4} sm={6}>
                    <b>214536878</b>
                    <p style={{ color: "#717171" }}>Order ID</p>
                  </Col>
                  <Col md={4} sm={6}>
                    <b>
                      {phase === 0 && "Pending"}
                      {phase === 1 && "Confirmed"}
                      {phase === 2 && "Food Preparing"}
                      {phase === 3 && "Ready To Pick"}
                      {phase === 4 && "Delivered"}
                      {phase === 5 && "Completed"}
                    </b>
                    <p style={{ color: "#717171" }}>Status</p>
                  </Col>
                  <Col md={4} sm={6}>
                    <b>29th August 2019</b>
                    <p style={{ color: "#717171" }}>Requested Date</p>
                  </Col>
                  <Col md={4} sm={6}>
                    <b>09:30 PM</b>
                    <p style={{ color: "#717171" }}>Requested Time</p>
                  </Col>
                  <Container fluid>
                    <hr />
                    <Row>
                      <Col xs={2} className="p-1">
                        <img
                          src={require("../../../../assets/images/Orders/Mask Group 113.png")}
                          width="100%"
                          alt="Rupees"
                        />
                      </Col>
                      <Col xs={8} className="p-1">
                        <h6>
                          <img
                            src={require("../../../../assets/images/superadmin/ordericon/veg.svg")}
                            width="15px"
                            heigth="15px"
                            alt="Veg Icon"
                          />{" "}
                          <b>Mexican Wave Pizza</b>
                        </h6>
                        Small
                        <p style={{ color: "#EE3A23" }}>Customized</p>
                        <p>
                          Crust: New Hand Tossed Add On: Onion, Capsicum,
                          Mushroom
                        </p>
                      </Col>
                      <Col xs={1} className="p-1">
                        <b>x1</b>
                      </Col>
                      <Col xs={1} className="p-1">
                        <b>₹ 450</b>
                      </Col>
                    </Row>
                  </Container>
                </Row>
              </div>
              <hr />
              <div className="row" style={{ marginTop: "30px" }}>
                <b>Notes For Kitchen</b>
                <p style={{ color: "#757575" }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam
                </p>
              </div>
            </div>
          </Col>
          <Col md={4}>
            <RightComponentOrderTrack phase={phase} />
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

const Menu = [
  {
    id: 0,
    selected: require("../../../../assets/images/superadmin/ordericon/hourglass-1.svg"),
    unselected: require("../../../../assets/images/superadmin/ordericon/Icons_25 nov-01 (1).svg"),
  },
  {
    id: 1,
    selected: require("../../../../assets/images/superadmin/ordericon/Icons_25 nov-09.svg"),
    unselected: require("../../../../assets/images/superadmin/ordericon/Icons_25 nov-01 (1).svg"),
  },
  {
    id: 2,
    selected: require("../../../../assets/images/superadmin/ordericon/Icons_25 nov-10.svg"),
    unselected: require("../../../../assets/images/superadmin/ordericon/chef-hat.svg"),
  },
  {
    id: 3,
    selected: require("../../../../assets/images/superadmin/ordericon/menu-01.svg"),
    unselected: require("../../../../assets/images/superadmin/ordericon/cloche.svg"),
  },
  {
    id: 4,
    selected: require("../../../../assets/images/superadmin/ordericon/Icons_25 nov-12.svg"),
    unselected: require("../../../../assets/images/superadmin/ordericon/cloche2.svg"),
  },
  {
    id: 5,
    selected: require("../../../../assets/images/superadmin/ordericon/Icons_25 nov-14.svg"),
    unselected: require("../../../../assets/images/superadmin/ordericon/round-done-button.svg"),
  },
];

const SliderMenu = (props) => {
  const [selected, setSel] = React.useState(props.phase);
  return (
    <React.Fragment>
      <Container
        fluid
        className="p-0"
        style={{ marginTop: "3%", marginBottom: "3%" }}
      >
        <div class="row">
          {Menu.map((data) => {
            return (
              <div
                class="col-sm-2"
                key={data.icon}
                style={{ padding: "25px" }}
                align="center"
              >
                <div
                  style={{
                    marginBottom: "10px",
                    height: "4px",
                    width: "100%",
                    backgroundColor:
                      selected >= data.id ? " #4CAF50" : "#E1E1E1",
                    borderRadius: " 4px",
                  }}
                ></div>
                <div
                  style={{
                    borderRadius: "50%",
                    backgroundColor:
                      selected >= data.id ? " #4CAF50" : "#E1E1E1",
                    height: "65%",
                    width: "75%",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setSel(data.id);
                    props.changePhase(data.id);
                  }}
                >
                  <img
                    src={selected >= data.id ? data.selected : data.unselected}
                    width="100%"
                    style={{
                      height: "100%",
                      padding: "15px",
                      position: "relative",
                    }}
                    alt="Select"
                  />
                </div>
              </div>
            );
          })}
        </div>
        {/* <Row>
          <Col sm={2}>
            <img
              src={require("../../../../assets/images/superadmin/ordericon/hourglass-1.svg")}
              width="100%"
            />{" "}
          </Col>
        </Row> */}
      </Container>
    </React.Fragment>
  );
};

export default OrderTrackMain;
